import { createContext, useContext, useEffect, useMemo, useRef, useState } from "react";
import { AuthProvider } from "react-oidc-context";
import { User } from 'oidc-client-ts';

interface IProjectContext {
    projectId: string | undefined;
    setProjectId: React.Dispatch<React.SetStateAction<string | undefined>>;
}
    
export const ProjectContext = createContext({} as IProjectContext);

export const ProjectProvider = (props: { 
    children: React.ReactElement 
}) => {

    const [projectId, setProjectId] = useState<string | undefined>(undefined);

    return (
        <ProjectContext.Provider
            value={{
                projectId,
                setProjectId
            }}
        >
            <AuthProvider
                authority={"https://baukgapp-vvot72.zitadel.cloud"}
                client_id={"224316569646334209@baukgapp-1"}
                response_type={"code"}
                redirect_uri={"http://localhost:3000/callback"}
                refreshTokenAllowedScope=''
                scope={`openid profile email urn:zitadel:iam:user:metadata ${projectId ? "" : ""}`}   
                onSigninCallback={(_user: User | void): void => { window.history.replaceState({}, document.title, window.location.pathname) }}     
            >
                { props.children }
            </AuthProvider>
        </ProjectContext.Provider>
    );

}